/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSidebarBlurbs_vipUserRelationship = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_vipUserRelationship",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_vipUserRelationship",
      "args": null
    }
  ],
  "type": "UserRelationship"
};

module.exports = fragment;
